/**
 * @file big-play-button.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _buttonJs = require('./button.js');

var _buttonJs2 = _interopRequireDefault(_buttonJs);

var _componentJs = require('./component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

/**
 * Initial play button. Shows before the video has played. The hiding of the
 * big play button is done via CSS and player states.
 *
 * @param {Object} player  Main Player
 * @param {Object=} options Object of option names and values
 * @extends Button
 * @class BigPlayButton
 */

var BigPlayButton = (function (_Button) {
  _inherits(BigPlayButton, _Button);

  function BigPlayButton(player, options) {
    _classCallCheck(this, BigPlayButton);

    _Button.call(this, player, options);
  }

  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */

  BigPlayButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-big-play-button';
  };

  /**
   * Handles click for play
   *
   * @method handleClick
   */

  BigPlayButton.prototype.handleClick = function handleClick() {
    this.player_.play();
  };

  /**
   * Return handler for the tooltip
   *
   * @return {Object} Dom element to serve as a handler for the tooltip
   * @method tooltipHandler
   */

  BigPlayButton.prototype.tooltipHandler = function tooltipHandler() {
    if (this.options_.tooltip !== undefined) {
      return _Button.prototype.tooltipHandler.call(this);
    }
  };

  return BigPlayButton;
})(_buttonJs2['default']);

BigPlayButton.prototype.controlText_ = 'Play Video';

_componentJs2['default'].registerComponent('BigPlayButton', BigPlayButton);
exports['default'] = BigPlayButton;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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